
import * as React from 'react';
import dayjs from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';
// MUI Table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Tooltip from '@mui/material/Tooltip';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export default function SortableFilterTable(props) {
    var utc = require('dayjs/plugin/utc')
    dayjs.extend(utc)

    /* props.columns
     {
       name:'',
       mappedProperty: '',
       dataType: 'numeric, date, string, none',
       canFilter: true/false
       customSorter: function or null
     }
     */



    const [currentSort, setCurrentSort] = React.useState({ Column: '', Direction: 'desc' });
    const [data, setData] = React.useState(props.data);
    const [showFilter, setShowFilter] = React.useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [expandedRow, setExpandedRow] = React.useState(null);

    const [currentFilters, setCurrentFilters] = React.useState({});

    React.useEffect(() => {
        let filters = {};
        for (let i = 0; i < props.columns.length; i++) {
            filters[props.columns[i].name] = '';
        }
        setCurrentFilters(filters);

    }, []);

    React.useEffect(() => {
        if (props.data != undefined) {
            setData(props.data);
            if (expandedRow !== null && props.uniqueIdentifierProperty !== undefined) {
                // make sure the expandedRow item is re-set
                for (let i = 0; i < props.data.length; i++) {
                    if (expandedRow[props.uniqueIdentifierProperty] == props.data[i][props.uniqueIdentifierProperty]) {
                        setExpandedRow(props.data[i]);
                        break;
                    }
                }
            }
        }

    }, [props.data]);

    function toggleSort(column) {
        let direction = '';
        if (currentSort.Column == column) {
            // toggle the direction

            if (currentSort.Direction == 'asc') {
                direction = 'desc';
            }
            else {
                direction = 'asc';
            }
            setCurrentSort({ Column: column, Direction: direction });
        }
        else {
            let direction = 'asc';
            setCurrentSort({ Column: column, Direction: 'asc' });
        }

        let clonedData = cloneDeep(data);
        let columnData = null;
        for (let i = 0; i < props.columns.length; i++) {
            if (props.columns[i].name == column) {
                columnData = props.columns[i];
                break;
            }
        }

        if (columnData != null) {
            // do the sorting
            if (columnData.customSorter != undefined) {
                if (typeof columnData.customSorter === 'function') {
                    data.sort(columnData.customSorter);
                }
            }
            else {
                if (columnData.dataType == 'string') {
                    clonedData.sort(sortComparator(columnData.mappedProperty))
                }
                else if (columnData.dataType == 'numeric') {
                    clonedData.sort(sortComparator(columnData.mappedProperty))
                }
                else if (columnData.dataType == 'money') {
                    clonedData.sort(sortComparator(columnData.mappedProperty))
                }
            }

        }

        if (direction == 'desc') {
            clonedData.reverse();
        }

        setData(clonedData);

    }
    function sortComparator(prop) {
        return function (a, b) {
            var aa = a[prop];
            var bb = b[prop];
            if (aa + 0 == aa && bb + 0 == bb) {
                return aa - bb;// numbers
            }
            else {
                return aa.localeCompare(bb); // strings
            }
        }
    }

    function toggleFilter(event, column, filtering) {

        let filters = cloneDeep(currentFilters);
        if (filtering) {
            filters[column] = '';
            setShowFilter(column);
        }
        else {
            setShowFilter(null);
        }

        if (filtering) {
            setAnchorEl(event.currentTarget);
        }
        else {
            setAnchorEl(null);
        }
    }

    function handleFilterChanged(column, value) {
        let columnData = null;
        for (let i = 0; i < props.columns.length; i++) {
            if (props.columns[i].name == column) {
                columnData = props.columns[i];
                break;
            }
        }

        if (columnData.dataType == 'numeric') {
            value.start = value.start == undefined ? '' : value.start.replace(/\D/g, '');
            value.end = value.end == undefined ? '' : value.end.replace(/\D/g, '');
        }


        let filters = cloneDeep(currentFilters);

        filters[column] = value;
        setCurrentFilters(filters);

        let tempData = cloneDeep(data);

        for (let i = 0; i < tempData.length; i++) {
            tempData[i].filtered = false;

            for (let key in filters) {
                let columnData = null;
                for (let i = 0; i < props.columns.length; i++) {
                    if (props.columns[i].name == key) {
                        columnData = props.columns[i];
                        break;
                    }
                }

                if (columnData.canFilter) {
                    if (filters[key] != '') {
                        if (columnData.dataType == 'numeric') {
                            if (isNaN(value)) {
                                // treat like an object {start: ##, end: ##}
                                if (tempData[i][columnData.mappedProperty] < parseFloat(filters[key].start) || tempData[i][columnData.mappedProperty] > parseFloat(filters[key].end)) {
                                    tempData[i].filtered = true;
                                }
                            }
                            else {
                                if (tempData[i][columnData.mappedProperty] !== parseFloat(filters[key])) {
                                    tempData[i].filtered = true;
                                }
                            }
                        }
                        else if (columnData.dataType == 'string') {
                            if (tempData[i][columnData.mappedProperty].toUpperCase().indexOf(filters[key].toUpperCase()) == -1) {
                                tempData[i].filtered = true;
                            }
                        }
                        else if (columnData.dataType == 'date') {
                            if (Object.prototype.toString.call(tempData[i][columnData.mappedProperty]) === '[object Date]') {
                                // value is a valid date
                            }
                        }
                    }
                }
            }
        }



        setData(tempData);

    }

    function buildFilter(column) {

        let columnData = null;
        for (let i = 0; i < props.columns.length; i++) {
            if (props.columns[i].name == column) {
                columnData = props.columns[i];
                break;
            }
        }

        if (columnData.dataType == 'numeric') {
            return (<div>
                <div>{showFilter}</div>
                <div style={{ display: 'flex' }}>

                    <TextField label={'Min'} value={currentFilters[column].start} onChange={(e) => handleFilterChanged(column, { start: e.target.value, end: currentFilters[column].end })} variant='outlined' style={{ alignSelf: 'center', maxWidth: '100px', marginRight: '5px' }} />
                    <TextField label={'Max'} value={currentFilters[column].end} onChange={(e) => handleFilterChanged(column, { start: currentFilters[column].start, end: e.target.value })} variant='outlined' style={{ alignSelf: 'center', maxWidth: '100px' }} />
                    <IconButton
                        onClick={() => handleFilterChanged(column, { start: '', end: '' })}
                        style={{
                            alignSelf: 'center',
                            visibility: currentFilters[column.name] == undefined ? null : currentFilters[column.name].start == '' && currentFilters[column.name].end == '' ? 'hidden' : 'visible'
                        }}><ClearIcon /></IconButton>
                </div>
            </div>)
        }
        else if (columnData.dataType == 'date') {

        }
        else {
            return (<div>
                <div style={{ display: 'flex' }}>
                    <TextField label={showFilter} value={currentFilters[column]} onChange={(e) => handleFilterChanged(column, e.target.value)} variant='outlined' style={{ alignSelf: 'center' }} />
                    <IconButton
                        onClick={() => handleFilterChanged(column, '')}
                        style={{
                            alignSelf: 'center',
                            visibility: currentFilters[column.name] == undefined ? null : currentFilters[column.name].trim() == '' ? 'hidden' : 'visible'
                        }}><ClearIcon /></IconButton>
                </div>
            </div>)
        }

    }

    function isFilteredColumn(columnName) {
        if (currentFilters[columnName] == undefined) {
            return false;
        }

        if (currentFilters[columnName].start !== undefined || currentFilters[columnName].end !== undefined) {
            // range check
            if (currentFilters[columnName].start !== undefined) {
                if (currentFilters[columnName].start != '') {
                    return true;
                }
            }

            if (currentFilters[columnName].end !== undefined) {
                if (currentFilters[columnName].end != '') {
                    return true;
                }
            }

            return false;
        }
        else {
            if (currentFilters[columnName] == '') {
                return false;
            }
        }

        return true;
    }

    function toggleExpandedItem(dataItem) {
        if (expandedRow == dataItem) {
            setExpandedRow(null);
        }
        else {
            setExpandedRow(dataItem);
        }
    }

    function formatMoney(number) {
        return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    return (
        <TableContainer component={Paper} className={'SortableFilterTable' + (props.expandRow == null ? '' : ' SortableFilterTableExpandable')}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {props.expandRow == null ? null :  
                            <TableCell></TableCell>
                        }
                        {
                            props.columns.map((column, index) => {
                                return (<TableCell key={column + '_' + index} style={{ color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', textAlign: column.align == undefined ? 'left' : column.align }}>
                                    {column.dataType === 'none' ?
                                        column.name
                                        :
                                        <TableSortLabel
                                            active={currentSort.Column === column.name}
                                            direction={currentSort.Direction}
                                            onClick={() => toggleSort(column.name)}
                                            style={{ color: 'white' }}
                                        >
                                            {column.name}
                                        </TableSortLabel>
                                    }
                                    {!column.canFilter ? null :
                                        <>
                                            <Tooltip title='Filter'>
                                                <IconButton onClick={(event) => toggleFilter(event, column.name, true)}>
                                                    <>
                                                        <MoreVertIcon sx={{ color: 'white' }} />
                                                        {!isFilteredColumn(column.name) ? null :
                                                            <FilterAltIcon sx={{ fontSize: 20, color: 'var(--sipzee-yellow)' }} style={{ position: 'absolute', left: '20px', top: '5px' }} />
                                                        }
                                                    </>
                                                </IconButton>

                                            </Tooltip>
                                            {showFilter !== column.name ? null :
                                                <Popover

                                                    open={showFilter === column.name}
                                                    anchorEl={anchorEl}
                                                    onClose={(event) => toggleFilter(event, column.name, false)}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'left',
                                                    }}
                                                >
                                                    <Typography sx={{ p: 2 }}>{buildFilter(column.name)}</Typography>
                                                </Popover>
                                            }
                                        </>
                                    }

                                </TableCell>
                                )
                            })
                        }

                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((dataItem) => {
                        if (!dataItem.filtered) {
                            return (
                                <>
                                    <TableRow>
                                        {props.expandRow == null ? null :
                                            <TableCell>
                                                <IconButton
                                                    aria-label="expand row"
                                                    size="small"
                                                    onClick={() => toggleExpandedItem(dataItem)}
                                                >
                                                    {expandedRow == dataItem ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                </IconButton>
                                            </TableCell>
                                        }
                                        {
                                            props.columns.map((column, index) => {

                                                return <TableCell style={{ textAlign: column.align == undefined ? 'left' : column.align }}>
                                                    {column.dataType === 'money' ?
                                                        formatMoney(dataItem[column.mappedProperty])
                                                    :
                                                        dataItem[column.mappedProperty]
                                                }
                                                   
                                                </TableCell>
                                            })
                                        }
                                    </TableRow>
                                    {
                                        props.expandRow == null ? null :
                                            <TableRow >
                                                <TableCell colSpan={props.columns.length + 1} style={{ padding: '0px' }}>
                                                   
                                                    <Collapse in={expandedRow == dataItem} timeout="auto" unmountOnExit>
                                                        {expandedRow == dataItem ? props.expandRow(dataItem) : null}
                                                        
                                                    </Collapse>
                                                    
                                                </TableCell>
                                            </TableRow>
                                    }
                                </>
                            )
                        }
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}